import React from 'react';
import '../css/AISection.css';

// Import images
import robotImage from '../assets/robot.png';
import automationImg from '../assets/automation.png';
import nlpImg from '../assets/nlp.png';
import analyticsImg from '../assets/predictive.png';
import recognitionImg from '../assets/recognition.png';

const AISection = () => {
  return (
    <section className="ai-section" id="ai">
      <div className="ai-container">
        {/* Heading & Description */}
        <h2>AI Solutions</h2>
        <p className="ai-intro">
          Explore the power of <strong>OzAI</strong> – a suite of AI-driven solutions to 
          revolutionize your workflow. From advanced automation to intelligent analytics, 
          our technology brings your ideas to life.
        </p>

        {/* 3D Robot Image */}
        <div className="robot-container">
          <img src={robotImage} alt="AI Robot" className="ai-robot" />
        </div>

        {/* Features Grid */}
        <div className="ai-features">
          <div className="ai-feature-card">
            <img src={automationImg} alt="Automation" className="ai-feature-img" />
            <h3>Automation</h3>
            <p>Automate repetitive tasks, increase productivity, and reduce operational costs.</p>
          </div>

          <div className="ai-feature-card">
            <img src={nlpImg} alt="Natural Language Processing" className="ai-feature-img" />
            <h3>Natural Language Processing</h3>
            <p>Transform text data into insights. Chatbots, sentiment analysis, entity extraction, and more.</p>
          </div>

          <div className="ai-feature-card">
            <img src={analyticsImg} alt="Predictive Analytics" className="ai-feature-img" />
            <h3>Predictive Analytics</h3>
            <p>Make data-driven decisions with real-time forecasting and anomaly detection.</p>
          </div>

          <div className="ai-feature-card">
            <img src={recognitionImg} alt="Image & Video Recognition" className="ai-feature-img" />
            <h3>Image & Video Recognition</h3>
            <p>Classify images, detect objects, track movements, and extract valuable information from videos.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AISection;
